import apiClient from './client';

export interface MedicalStatistics {
  sensitiveIncluded: boolean;
  coverage: {
    totalPersons: number;
    deceased: number;
    withConditions: number;
    withTraits: number;
    deceasedWithCause: number;
  };
  topCausesOfDeath: { label: string; count: number }[];
  causesByDecade: { decade: string; count: number }[];
  conditionsByInheritance: { pattern: string; count: number }[] | null;
  ascertainment: { level: string; count: number }[];
  traitDistributions: {
    traitType: string;
    values: { value: string; count: number }[];
    numeric: { count: number; min: number; avg: number; max: number } | null;
  }[];
}

export async function getMedicalStatistics(): Promise<MedicalStatistics> {
  const { data } = await apiClient.get<MedicalStatistics>('/medical/statistics');
  return data;
}
